// extracted by mini-css-extract-plugin
module.exports = {"header":"TableDrawer_header__iHgFi","title":"TableDrawer_title__mi1KA"};